export default "__VITE_ASSET__Dk8td6Xe__"